import { render, staticRenderFns } from "./formtextarea.vue?vue&type=template&id=5f8f19e6&"
import script from "./formtextarea.vue?vue&type=script&lang=js&"
export * from "./formtextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports